module.exports = __webpack_public_path__ + "static/media/1019783.941a5339.jpg";